var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Command, CommandData } from "./command";
export class CompositeCommand extends Command {
    constructor(description) {
        super(description);
        this._commands = [];
    }
    get id() {
        return CompositeCommandData.ID;
    }
    addCommand(command) {
        this._commands.push(command);
    }
    get count() {
        return this._commands.length;
    }
    get commands() {
        return this._commands.slice(0);
    }
    do() {
        return __awaiter(this, void 0, void 0, function* () {
            let anyDo = false;
            for (let command of this._commands)
                anyDo = (yield command.do()) || anyDo;
            return anyDo;
        });
    }
    undo() {
        return __awaiter(this, void 0, void 0, function* () {
            let anyUndo = false;
            for (let i = this._commands.length - 1; i >= 0; i--)
                anyUndo = (yield this._commands[i].undo()) || anyUndo;
            return anyUndo;
        });
    }
    getData() {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            for (let command of this._commands)
                data.push(yield command.getData());
            return {
                id: this.id,
                data
            };
        });
    }
}
export var CompositeCommandData;
(function (CompositeCommandData) {
    CompositeCommandData.ID = 'Composite';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === CompositeCommandData.ID
            && 'data' in arg
            && Array.isArray(arg.data);
    }
    CompositeCommandData.is = is;
})(CompositeCommandData || (CompositeCommandData = {}));
//# sourceMappingURL=composite-command.js.map